import { render } from "./QuestionSkeleton.vue?vue&type=template&id=f6d0d2dc&scoped=true"
const script = {}

import "./QuestionSkeleton.vue?vue&type=style&index=0&id=f6d0d2dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d0d2dc"]])

export default __exports__